import { render, staticRenderFns } from "./DetailPermohonanIzinLokasi.vue?vue&type=template&id=e344a11a&"
import script from "./DetailPermohonanIzinLokasi.vue?vue&type=script&lang=js&"
export * from "./DetailPermohonanIzinLokasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports